import { site } from "../data/content";
import { ArrowDownRight } from "lucide-react";
import { Link } from "react-router-dom";
import Brand from "./Brand";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-28 md:pt-36 pb-20 md:pb-28 grain-overlay"
      style={{ backgroundColor: "var(--bg)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 relative z-10">
        <div className="lg:col-span-8 fade-up">
          <div className="mb-6 flex items-center gap-3">
            <Brand size="sm" />
            <span className="overline">· Decarbonization Practice</span>
          </div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight" style={{ color: "var(--primary)" }}>
            Decarbonizing heavy industry,<br />
            <span style={{ color: "var(--accent)", fontStyle: "italic" }}>profitably</span> — one Gigawatt at a time.
          </h1>
          <p className="mt-8 max-w-2xl text-lg md:text-xl leading-relaxed" style={{ color: "var(--text-secondary)" }}>
            I&apos;m {site.name} — an <mark className="hl">award-winning decarbonization expert</mark>. Over{" "}
            <mark className="hl">15 years</mark> I have delivered <mark className="hl">$13.7 B+</mark> of hybrid{" "}
            <mark className="hl">PV, Wind and Energy Storage</mark> projects across{" "}
            <mark className="hl">15 countries</mark> for mines, smelters and IPPs — including the{" "}
            <mark className="hl">world&apos;s first time-block renewable product</mark>, for a{" "}
            <mark className="hl">2.5 GW mining load of a leading mining operator</mark>.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-5">
            <Link
              to="/projects"
              data-testid="hero-explore-projects"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm tracking-wide transition-colors"
              style={{ backgroundColor: "var(--primary)", color: "var(--bg)" }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--primary-hover)")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--primary)")}
            >
              Explore the project atlas <ArrowDownRight size={16} />
            </Link>
            <Link
              to="/about"
              data-testid="hero-read-bio"
              className="text-sm link-underline font-semibold"
              style={{ color: "var(--primary)" }}
            >
              Read bio
            </Link>
          </div>
        </div>

        <div className="lg:col-span-4 flex lg:justify-end items-start fade-up delay-2">
          <div className="p-8 w-full max-w-sm" style={{ border: "1px solid var(--border-soft)", backgroundColor: "var(--surface)" }}>
            <div className="overline">A Practice</div>
            <div className="mt-6 font-serif text-3xl leading-tight" style={{ color: "var(--primary)" }}>
              Founded by<br />
              <span style={{ fontStyle: "italic" }}>Himansshu Agrawal</span>
            </div>
            <div className="mt-8 overline">Global Reach</div>
            <div className="mt-3 text-sm font-mono font-semibold tracking-wide leading-relaxed" style={{ color: "var(--text-primary)" }}>
              {site.regions.map((r, i) => (
                <span key={r}>
                  {r.toUpperCase()}
                  {i < site.regions.length - 1 && <span style={{ color: "var(--accent-strong)" }}> · </span>}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
